import { Controller } from "@hotwired/stimulus";
import "react_ujs";

export default class extends Controller {
  static targets = ["productSelect"];
  static values = {
    productType: String,
    itemId: String,
    estimateId: String,
    latestColor: String,
    duplicate: Boolean,
    hidePrices: Boolean,
  };

  initialize() {
    const targets = this.productSelectTargets;
    const checkedRadio = targets.find((el) => el.checked);

    if (checkedRadio) {
      this.loadOptionsWithValue(checkedRadio.value);
    } else if (targets.length === 1 && targets[0].value) {
      this.loadOptionsWithValue(targets[0].value);
    }
  }

  loadOptions(event) {
    this.loadOptionsWithValue(event.target.value);
  }

  loadOptionsWithValue(productId) {
    if (!productId) return;

    const optionsFrame = document.getElementById(
      `${this.productTypeValue}_options`
    );
    const params = new URLSearchParams();

    if (this.itemIdValue) {
      params.append(`${this.productTypeValue}_item_id`, this.itemIdValue);
    }

    if (this.estimateIdValue) {
      params.append("estimate_id", this.estimateIdValue);
    }

    if (this.latestColorValue) {
      params.append("latest_color", this.latestColorValue);
    }

    if (this.duplicateValue) {
      params.append("duplicate", "true");
    }

    if (this.hidePricesValue) {
      params.append("hide_prices", "true");
    }

    optionsFrame.src = `/sales/${
      this.productTypeValue
    }_products/${productId}/options?${params.toString()}`;

    optionsFrame.addEventListener(
      "turbo:frame-load",
      this.initializeReactComponents,
      { once: true }
    );
  }

  initializeReactComponents() {
    ReactRailsUJS.handleMount();
  }
}
